import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=8d9582d6&scoped=true"
import script from "./BrandDetail.vue?vue&type=script&lang=js"
export * from "./BrandDetail.vue?vue&type=script&lang=js"
import style0 from "./BrandDetail.vue?vue&type=style&index=0&id=8d9582d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9582d6",
  null
  
)

export default component.exports